var _defs, _path, _path2, _circle, _circle2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_f0757b882e042343af91247c8e0deff534dd9bf3d7dd61ccfcc10714022be5f4",
    x1: 41.549,
    y1: 101.669,
    x2: 84.229,
    y2: 101.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_f0757b882e042343af91247c8e0deff534dd9bf3d7dd61ccfcc10714022be5f4",
    "data-name": "C_BG_shellbar",
    x1: 27.82,
    y1: 76.098,
    x2: 70.499,
    y2: 76.098,
    xlinkHref: "#SVGID_0_f0757b882e042343af91247c8e0deff534dd9bf3d7dd61ccfcc10714022be5f4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M58.399 72.112c3.33-4.38 7.86-8.25 13.58-11.33 18.59-9.56 20.98-21.24 20.98-21.24M113.669 40.332s2.39 10.89 20.97 20.45c20.71 11.15 25.79 32.67 15.4 50.97-4.99 8.79-17.26 19.69-46.73 19.69s-41.74-10.9-46.72-19.69c-1.14-2-2.09-4.04-2.85-6.09M51.729 97.842c-.89-6.14-.17-12.27 2.17-17.92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M92.958 39.539l-6.372-19.116s5.045-2.124 15.134 4.248c7.965 5.177 19.116-3.186 19.116-3.186l-7.169 18.851M92.958 39.539s8.762 7.965 20.709.797"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 96.21,
    cy: 81.118,
    r: 4.047
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 111.211,
    cy: 97.988,
    r: 4.047
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M93.162 101.802l21.311-24.767"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_f0757b882e042343af91247c8e0deff534dd9bf3d7dd61ccfcc10714022be5f4)",
    d: "M42.799 97.841v7.818h26.824v9.446l13.356-14.006-13.681-12.867v9.609H42.799zM69.249 79.926v-7.818H42.425v-9.446L29.07 76.668l13.68 12.867v-9.609h26.499z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanTransactions);
export default __webpack_public_path__ + "static/media/loanTransactions.1b81a17226973ba28a0551460791c5dd.svg";
export { ForwardRef as ReactComponent };